var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"color":"grey lighten-4"}},[_c('v-toolbar',{attrs:{"height":"100px"}},[_c('v-row',[_c('v-col',[_c('img',{staticClass:"imageSize",attrs:{"src":require("../../assets/gfiretail.png")}})])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }